<template>
  <div>
    <NuxtPage />
    <!--
      Serves both the login batch and a single announcement opened from the What's New panel.
      Mounted here rather than beside the panel because on mobile the panel lives inside the
      slide-out menu, and clicking a row closes that menu — which would unmount anything the
      panel itself rendered.
    -->
    <FeatureAnnouncementModalContainer v-if="isFeatureAnnouncementEnabled" />

    <!--
      The single app-wide render site for a running Guided Walkthrough. Mounted once here,
      outside NuxtPage, so a walkthrough survives the route change that launching it from
      the What's New panel performs. Everything that starts one only calls the controller.
    -->
    <WalkthroughController v-if="isFeatureAnnouncementEnabled" />
  </div>
</template>

<script setup>
// Same gate the What's New nav entry and panel use, so the flag can never be on for one
// entry point and off for the other.
const { isFeatureAnnouncementEnabled } = useIsFeatureAnnouncementEnabled();
</script>
